import { useForm } from "@/form";
import { defineStore } from "pinia";

export const useStore = defineStore("templates", {
    state: () => {
        return {
            templatesData: [],
            isLoadedData: false,
        };
    },

    getters: {
        templates: (state) => {
            return state.templatesData;
        },
    },

    actions: {
        async fetch() {
            try {
                this.isLoadedData = false;
                this.templatesData = await useForm().post("templates_index");
                this.isLoadedData = true;
            } catch (error) {
                return error;
            }
        },
    },
});
